<template>
  <div class="text-center cursor-pointer  " v-if="this.params.data.status == '0'" style="float: left">
    <a  @click="confirmDeleteRecord"> {{$t('managePackage.a')}}</a>
  </div>
</template>

<script>
  export default {
    name: 'CellRendererActions',
    methods: {
      confirmDeleteRecord() {
        this.$store.commit('SHOW_CONFIRM_CANCEL_PACKAGE', true);
        this.$store.commit('UPDATE_ID',this.params.data.id);
      },
    }
  }
</script>
